import type { KeyboardEvent } from 'react'
import { useNls } from '../../../nls/nlsProvider'
import type { ChartDescriptor } from '../charts'
import { useChartPopover } from './useChartPopover'

export const usePoppableCard = (descriptor?: ChartDescriptor | null) => {
  const { t } = useNls()
  const { openChart } = useChartPopover()
  if (!descriptor) return { poppable: false as const, cardProps: {} }
  const label = `${t('NLSAnalysisChartActionExpand')} · ${descriptor.title}`
  const onActivate = () => openChart(descriptor)
  return {
    poppable: true as const,
    cardProps: {
      role: 'button' as const,
      tabIndex: 0,
      title: label,
      'aria-label': label,
      onClick: onActivate,
      onKeyDown: (e: KeyboardEvent) => {
        if (e.target !== e.currentTarget) return // let inner glyphs handle their own keys
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault()
          onActivate()
        }
      },
      className: 'analysisPoppableCard',
    },
  }
}
